// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== RESET & BASE STYLES ==================== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  /* Clear/Sunny Theme (Default) */
  --bg-gradient-start: #87ceeb;
  --bg-gradient-end: #4a90e2;
  --text-primary: #1f2937;
  --text-secondary: #4b5563;
  --text-light: #f9fafb;
  --card-bg: rgba(255, 255, 255, 0.9);
  --card-shadow: rgba(0, 0, 0, 0.1);
  --accent-color: #f59e0b;
  --accent-hover: #d97706;
  --error-color: #ef4444;
  --border-color: rgba(255, 255, 255, 0.3);
}

body {
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
    Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  line-height: 1.6;
  background: linear-gradient(
    135deg,
    var(--bg-gradient-start),
    var(--bg-gradient-end)
  );
  min-height: 100vh;
  color: var(--text-primary);
  transition: background 0.5s ease;
}

/* ==================== WEATHER THEMES ==================== */
body.clear {
  --bg-gradient-start: #87ceeb;
  --bg-gradient-end: #4a90e2;
  --text-primary: #1f2937;
  --card-bg: rgba(255, 255, 255, 0.9);
}

body.cloudy {
  --bg-gradient-start: #b0bec5;
  --bg-gradient-end: #78909c;
  --text-primary: #1f2937;
  --card-bg: rgba(255, 255, 255, 0.85);
}

body.rain {
  --bg-gradient-start: #4a5568;
  --bg-gradient-end: #2d3748;
  --text-primary: #f9fafb;
  --text-secondary: #e5e7eb;
  --card-bg: rgba(45, 55, 72, 0.8);
  --border-color: rgba(255, 255, 255, 0.2);
}

body.snow {
  --bg-gradient-start: #e0f2fe;
  --bg-gradient-end: #bae6fd;
  --text-primary: #1e3a8a;
  --card-bg: rgba(255, 255, 255, 0.9);
}

body.night {
  --bg-gradient-start: #1a202c;
  --bg-gradient-end: #2c5282;
  --text-primary: #f9fafb;
  --text-secondary: #e5e7eb;
  --card-bg: rgba(26, 32, 44, 0.85);
  --border-color: rgba(255, 255, 255, 0.15);
}

/* ==================== LAYOUT ==================== */
.app-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* ==================== HEADER ==================== */
.header {
  text-align: center;
  margin-bottom: 2rem;
}

.app-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  text-shadow: 2px 2px 4px var(--card-shadow);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.app-title i {
  font-size: 2.5rem;
  color: var(--accent-color);
}

/* ==================== SEARCH SECTION ==================== */
.search-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
  align-items: center;
}

.search-form {
  width: 100%;
  max-width: 600px;
}

.search-input-group {
  display: flex;
  gap: 0.5rem;
  background: var(--card-bg);
  padding: 0.5rem;
  border-radius: 50px;
  box-shadow: 0 4px 6px var(--card-shadow);
  backdrop-filter: blur(10px);
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 0.75rem 1.25rem;
  font-size: 1rem;
  color: var(--text-primary);
  outline: none;
}

.search-input::placeholder {
  color: var(--text-secondary);
  opacity: 0.7;
}

.search-btn {
  background: var(--accent-color);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.search-btn:hover {
  background: var(--accent-hover);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
}

.search-btn:active {
  transform: translateY(0);
}

/* ==================== TEMPERATURE TOGGLE ==================== */
.temp-toggle {
  display: flex;
  gap: 0.5rem;
  background: var(--card-bg);
  padding: 0.5rem;
  border-radius: 50px;
  box-shadow: 0 4px 6px var(--card-shadow);
  backdrop-filter: blur(10px);
}

.toggle-btn {
  padding: 0.5rem 1.5rem;
  border: 2px solid transparent;
  background: transparent;
  color: var(--text-secondary);
  font-size: 1rem;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.toggle-btn.active {
  background: var(--accent-color);
  color: white;
  border-color: var(--accent-color);
}

.toggle-btn:not(.active):hover {
  background: rgba(245, 158, 11, 0.1);
  border-color: var(--accent-color);
}

/* ==================== LOADING SPINNER ==================== */
.loading-spinner {
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 3rem;
  color: var(--text-primary);
}

.loading-spinner.active {
  display: flex;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 4px solid var(--border-color);
  border-top: 4px solid var(--accent-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* ==================== ERROR MESSAGE ==================== */
.error-message {
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  background: var(--card-bg);
  border-radius: 20px;
  box-shadow: 0 10px 30px var(--card-shadow);
  backdrop-filter: blur(10px);
  max-width: 500px;
  margin: 2rem auto;
  text-align: center;
}

.error-message.active {
  display: flex;
}

.error-message i {
  font-size: 3rem;
  color: var(--error-color);
}

.error-text {
  color: var(--text-primary);
  font-size: 1.1rem;
}

.retry-btn {
  background: var(--accent-color);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.retry-btn:hover {
  background: var(--accent-hover);
  transform: translateY(-2px);
}

/* ==================== WEATHER DISPLAY ==================== */
.weather-display {
  display: none;
  gap: 2rem;
  flex: 1;
}

.weather-display.active {
  display: flex;
  flex-direction: column;
}

/* ==================== CURRENT WEATHER ==================== */
.current-weather {
  background: var(--card-bg);
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px var(--card-shadow);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
}

.location-info {
  text-align: center;
  margin-bottom: 2rem;
}

.location-name {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.current-date {
  font-size: 1rem;
  color: var(--text-secondary);
}

.current-conditions {
  text-align: center;
  margin-bottom: 2rem;
}

.temp-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.weather-icon {
  font-size: 5rem;
  color: var(--accent-color);
}

.temp-info {
  display: flex;
  align-items: flex-start;
}

.current-temp {
  font-size: 5rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1;
}

.temp-unit {
  font-size: 2rem;
  color: var(--text-secondary);
  margin-left: 0.25rem;
}

.weather-description {
  font-size: 1.5rem;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.feels-like {
  font-size: 1rem;
  color: var(--text-secondary);
}

/* ==================== WEATHER DETAILS GRID ==================== */
.weather-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid var(--border-color);
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.detail-item i {
  font-size: 2rem;
  color: var(--accent-color);
}

.detail-info {
  flex: 1;
}

.detail-label {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin-bottom: 0.25rem;
}

.detail-value {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
}

/* ==================== FORECAST SECTION ==================== */
.forecast-section {
  background: var(--card-bg);
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px var(--card-shadow);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
}

.forecast-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 1.5rem;
  text-align: center;
}

.forecast-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
}

.forecast-card {
  background: rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: 15px;
  text-align: center;
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

.forecast-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px var(--card-shadow);
}

.forecast-day {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.forecast-icon {
  font-size: 2.5rem;
  color: var(--accent-color);
  margin: 0.5rem 0;
}

.forecast-temps {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1rem;
  color: var(--text-primary);
}

.forecast-high {
  font-weight: 600;
}

.forecast-low {
  color: var(--text-secondary);
}

/* ==================== FOOTER ==================== */
.footer {
  text-align: center;
  margin-top: 3rem;
  padding: 2rem 1rem;
  color: var(--text-primary);
  opacity: 0.8;
}

.footer p {
  margin: 0.5rem 0;
  font-size: 0.875rem;
}

.footer a {
  color: var(--accent-color);
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.footer a:hover {
  color: var(--accent-hover);
  text-decoration: underline;
}

/* ==================== RESPONSIVE DESIGN ==================== */
@media (max-width: 768px) {
  .app-title {
    font-size: 2rem;
  }

  .app-title i {
    font-size: 2rem;
  }

  .search-input-group {
    flex-direction: column;
    border-radius: 15px;
  }

  .search-input,
  .search-btn {
    width: 100%;
    border-radius: 10px;
  }

  .current-temp {
    font-size: 4rem;
  }

  .weather-icon {
    font-size: 4rem;
  }

  .temp-unit {
    font-size: 1.5rem;
  }

  .weather-details {
    grid-template-columns: repeat(2, 1fr);
  }

  .forecast-grid {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
}

@media (max-width: 480px) {
  .app-container {
    padding: 1rem 0.5rem;
  }

  .app-title {
    font-size: 1.5rem;
    flex-direction: column;
    gap: 0.5rem;
  }

  .current-weather,
  .forecast-section {
    padding: 1.5rem 1rem;
  }

  .weather-details {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,mCAAmC;EACnC,iCAAiC;EACjC,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE;;wDAEsD;EACtD,gBAAgB;EAChB;;;;GAIC;EACD,iBAAiB;EACjB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,6DAA6D;AAC7D;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA,qDAAqD;AACrD;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,yCAAyC;EACzC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,gEAAgE;AAChE;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ==================== RESET & BASE STYLES ==================== */\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n:root {\r\n  /* Clear/Sunny Theme (Default) */\r\n  --bg-gradient-start: #87ceeb;\r\n  --bg-gradient-end: #4a90e2;\r\n  --text-primary: #1f2937;\r\n  --text-secondary: #4b5563;\r\n  --text-light: #f9fafb;\r\n  --card-bg: rgba(255, 255, 255, 0.9);\r\n  --card-shadow: rgba(0, 0, 0, 0.1);\r\n  --accent-color: #f59e0b;\r\n  --accent-hover: #d97706;\r\n  --error-color: #ef4444;\r\n  --border-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\nbody {\r\n  font-family:\r\n    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,\r\n    Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\r\n  line-height: 1.6;\r\n  background: linear-gradient(\r\n    135deg,\r\n    var(--bg-gradient-start),\r\n    var(--bg-gradient-end)\r\n  );\r\n  min-height: 100vh;\r\n  color: var(--text-primary);\r\n  transition: background 0.5s ease;\r\n}\r\n\r\n/* ==================== WEATHER THEMES ==================== */\r\nbody.clear {\r\n  --bg-gradient-start: #87ceeb;\r\n  --bg-gradient-end: #4a90e2;\r\n  --text-primary: #1f2937;\r\n  --card-bg: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\nbody.cloudy {\r\n  --bg-gradient-start: #b0bec5;\r\n  --bg-gradient-end: #78909c;\r\n  --text-primary: #1f2937;\r\n  --card-bg: rgba(255, 255, 255, 0.85);\r\n}\r\n\r\nbody.rain {\r\n  --bg-gradient-start: #4a5568;\r\n  --bg-gradient-end: #2d3748;\r\n  --text-primary: #f9fafb;\r\n  --text-secondary: #e5e7eb;\r\n  --card-bg: rgba(45, 55, 72, 0.8);\r\n  --border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\nbody.snow {\r\n  --bg-gradient-start: #e0f2fe;\r\n  --bg-gradient-end: #bae6fd;\r\n  --text-primary: #1e3a8a;\r\n  --card-bg: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\nbody.night {\r\n  --bg-gradient-start: #1a202c;\r\n  --bg-gradient-end: #2c5282;\r\n  --text-primary: #f9fafb;\r\n  --text-secondary: #e5e7eb;\r\n  --card-bg: rgba(26, 32, 44, 0.85);\r\n  --border-color: rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n/* ==================== LAYOUT ==================== */\r\n.app-container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 2rem 1rem;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* ==================== HEADER ==================== */\r\n.header {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.app-title {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  text-shadow: 2px 2px 4px var(--card-shadow);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.app-title i {\r\n  font-size: 2.5rem;\r\n  color: var(--accent-color);\r\n}\r\n\r\n/* ==================== SEARCH SECTION ==================== */\r\n.search-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n  margin-bottom: 2rem;\r\n  align-items: center;\r\n}\r\n\r\n.search-form {\r\n  width: 100%;\r\n  max-width: 600px;\r\n}\r\n\r\n.search-input-group {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  background: var(--card-bg);\r\n  padding: 0.5rem;\r\n  border-radius: 50px;\r\n  box-shadow: 0 4px 6px var(--card-shadow);\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.search-input {\r\n  flex: 1;\r\n  border: none;\r\n  background: transparent;\r\n  padding: 0.75rem 1.25rem;\r\n  font-size: 1rem;\r\n  color: var(--text-primary);\r\n  outline: none;\r\n}\r\n\r\n.search-input::placeholder {\r\n  color: var(--text-secondary);\r\n  opacity: 0.7;\r\n}\r\n\r\n.search-btn {\r\n  background: var(--accent-color);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 2rem;\r\n  border-radius: 50px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.search-btn:hover {\r\n  background: var(--accent-hover);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);\r\n}\r\n\r\n.search-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n/* ==================== TEMPERATURE TOGGLE ==================== */\r\n.temp-toggle {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  background: var(--card-bg);\r\n  padding: 0.5rem;\r\n  border-radius: 50px;\r\n  box-shadow: 0 4px 6px var(--card-shadow);\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.toggle-btn {\r\n  padding: 0.5rem 1.5rem;\r\n  border: 2px solid transparent;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  border-radius: 50px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.toggle-btn.active {\r\n  background: var(--accent-color);\r\n  color: white;\r\n  border-color: var(--accent-color);\r\n}\r\n\r\n.toggle-btn:not(.active):hover {\r\n  background: rgba(245, 158, 11, 0.1);\r\n  border-color: var(--accent-color);\r\n}\r\n\r\n/* ==================== LOADING SPINNER ==================== */\r\n.loading-spinner {\r\n  display: none;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  padding: 3rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.loading-spinner.active {\r\n  display: flex;\r\n}\r\n\r\n.spinner {\r\n  width: 60px;\r\n  height: 60px;\r\n  border: 4px solid var(--border-color);\r\n  border-top: 4px solid var(--accent-color);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* ==================== ERROR MESSAGE ==================== */\r\n.error-message {\r\n  display: none;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 2rem;\r\n  background: var(--card-bg);\r\n  border-radius: 20px;\r\n  box-shadow: 0 10px 30px var(--card-shadow);\r\n  backdrop-filter: blur(10px);\r\n  max-width: 500px;\r\n  margin: 2rem auto;\r\n  text-align: center;\r\n}\r\n\r\n.error-message.active {\r\n  display: flex;\r\n}\r\n\r\n.error-message i {\r\n  font-size: 3rem;\r\n  color: var(--error-color);\r\n}\r\n\r\n.error-text {\r\n  color: var(--text-primary);\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.retry-btn {\r\n  background: var(--accent-color);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 2rem;\r\n  border-radius: 50px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.retry-btn:hover {\r\n  background: var(--accent-hover);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* ==================== WEATHER DISPLAY ==================== */\r\n.weather-display {\r\n  display: none;\r\n  gap: 2rem;\r\n  flex: 1;\r\n}\r\n\r\n.weather-display.active {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* ==================== CURRENT WEATHER ==================== */\r\n.current-weather {\r\n  background: var(--card-bg);\r\n  padding: 2rem;\r\n  border-radius: 20px;\r\n  box-shadow: 0 10px 30px var(--card-shadow);\r\n  backdrop-filter: blur(10px);\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.location-info {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.location-name {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.current-date {\r\n  font-size: 1rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.current-conditions {\r\n  text-align: center;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.temp-display {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.weather-icon {\r\n  font-size: 5rem;\r\n  color: var(--accent-color);\r\n}\r\n\r\n.temp-info {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.current-temp {\r\n  font-size: 5rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  line-height: 1;\r\n}\r\n\r\n.temp-unit {\r\n  font-size: 2rem;\r\n  color: var(--text-secondary);\r\n  margin-left: 0.25rem;\r\n}\r\n\r\n.weather-description {\r\n  font-size: 1.5rem;\r\n  color: var(--text-primary);\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.feels-like {\r\n  font-size: 1rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ==================== WEATHER DETAILS GRID ==================== */\r\n.weather-details {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n  gap: 1.5rem;\r\n  margin-top: 2rem;\r\n  padding-top: 2rem;\r\n  border-top: 2px solid var(--border-color);\r\n}\r\n\r\n.detail-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.detail-item i {\r\n  font-size: 2rem;\r\n  color: var(--accent-color);\r\n}\r\n\r\n.detail-info {\r\n  flex: 1;\r\n}\r\n\r\n.detail-label {\r\n  font-size: 0.875rem;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.detail-value {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* ==================== FORECAST SECTION ==================== */\r\n.forecast-section {\r\n  background: var(--card-bg);\r\n  padding: 2rem;\r\n  border-radius: 20px;\r\n  box-shadow: 0 10px 30px var(--card-shadow);\r\n  backdrop-filter: blur(10px);\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.forecast-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin-bottom: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.forecast-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.forecast-card {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  padding: 1rem;\r\n  border-radius: 15px;\r\n  text-align: center;\r\n  border: 1px solid var(--border-color);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.forecast-card:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 8px 20px var(--card-shadow);\r\n}\r\n\r\n.forecast-day {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.forecast-icon {\r\n  font-size: 2.5rem;\r\n  color: var(--accent-color);\r\n  margin: 0.5rem 0;\r\n}\r\n\r\n.forecast-temps {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  font-size: 1rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.forecast-high {\r\n  font-weight: 600;\r\n}\r\n\r\n.forecast-low {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ==================== FOOTER ==================== */\r\n.footer {\r\n  text-align: center;\r\n  margin-top: 3rem;\r\n  padding: 2rem 1rem;\r\n  color: var(--text-primary);\r\n  opacity: 0.8;\r\n}\r\n\r\n.footer p {\r\n  margin: 0.5rem 0;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.footer a {\r\n  color: var(--accent-color);\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.footer a:hover {\r\n  color: var(--accent-hover);\r\n  text-decoration: underline;\r\n}\r\n\r\n/* ==================== RESPONSIVE DESIGN ==================== */\r\n@media (max-width: 768px) {\r\n  .app-title {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .app-title i {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .search-input-group {\r\n    flex-direction: column;\r\n    border-radius: 15px;\r\n  }\r\n\r\n  .search-input,\r\n  .search-btn {\r\n    width: 100%;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .current-temp {\r\n    font-size: 4rem;\r\n  }\r\n\r\n  .weather-icon {\r\n    font-size: 4rem;\r\n  }\r\n\r\n  .temp-unit {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .weather-details {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .forecast-grid {\r\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .app-container {\r\n    padding: 1rem 0.5rem;\r\n  }\r\n\r\n  .app-title {\r\n    font-size: 1.5rem;\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .current-weather,\r\n  .forecast-section {\r\n    padding: 1.5rem 1rem;\r\n  }\r\n\r\n  .weather-details {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
